import { useStartupTokenRefresh } from '@hooks/useStartupTokenRefresh'

const AuthInitializer: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  useStartupTokenRefresh()
  return <>{children}</>
}

export default AuthInitializer
